
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setLoading, setFeesAndCharges, setError } from "../../features/common/convenienceFeesAndChargesSlice";
import { deleteById, fetchConvenienceFeesAndCharges } from "../../services/userservice";
import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";

const ConvenienceFeesAndChargesList = () => {

    const dispatch = useDispatch();
    const [currentPage, setCurrentPage] = useState(1);
        const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [deleteUser, setDeleteUser] = useState("")
    const { feesAndCharges, loading, error } = useSelector((state) => state.convenienceFeesAndCharges);

    useEffect(() => {
        const fetchData = async () => {
            dispatch(setLoading());
            try {
                const data = await fetchConvenienceFeesAndCharges();
                dispatch(setFeesAndCharges(data));
            } catch (err) {
                dispatch(setError(err.message));
            }
        };
        fetchData();
    }, [dispatch, deleteUser]);


    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };


    const filteredCategories = feesAndCharges.filter((category) =>
        category?.title?.toLowerCase().includes(searchTerm.toLowerCase())
    );



    const handleDelete = async () => {
        try {
            const deleteResponse = await deleteById(selectedUserId);
            if (deleteResponse.status === 200 || deleteResponse.status === 201) {
                setDeleteUser(selectedUserId);
                closeModal();
            } else {
                setError(deleteResponse.message || "Failed to delete user");
            }
        } catch (error) {
            alert("You are not authorized to delete this user");
        }
    };

    const openModal = (id) => {
        setSelectedUserId(id);
        setShowModal(true);
    };


    const closeModal = () => {
        setShowModal(false);
    };


    const confirmDelete = async () => {
        await handleDelete(selectedUserId);
        closeModal();
    };


    // Table rows to show per page Start

    const indexOfLastCategory = currentPage * rowsPerPage;
    const indexOfFirstCategory = indexOfLastCategory - rowsPerPage;
    const currentCategories = filteredCategories.slice(indexOfFirstCategory, indexOfLastCategory);

    // bottom pagination start

    const totalPages = Math.ceil(filteredCategories.length / rowsPerPage);

    const renderPageNumbers = () => {
        const pages = [];
        const maxPagesToShow = 3;

        if (totalPages <= 10) {
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
            }
        } else {
            // Always show first 3 pages
            pages.push(1, 2, 3);

            // Show "..." if currentPage is beyond 5
            if (currentPage > 5) {
                pages.push("...");
            }

            // Show current page and neighbors
            const start = Math.max(4, currentPage - 1);
            const end = Math.min(totalPages - 3, currentPage + 1);

            for (let i = start; i <= end; i++) {
                if (!pages.includes(i)) pages.push(i);
            }

            // Show "..." if currentPage is far from end
            if (currentPage < totalPages - 4) {
                pages.push("...");
            }

            // Always show last 3 pages
            pages.push(totalPages - 2, totalPages - 1, totalPages);
        }

        return pages.map((page, index) => (
            <li
                key={index}
                className={`page-item ${page === currentPage ? "active" : ""} ${page === "..." ? "disabled" : ""}`}
            >
                {page === "..." ? (
                    <span className="page-link">...</span>
                ) : (
                    <button className="page-link" onClick={() => setCurrentPage(page)}>
                        {page}
                    </button>
                )}
            </li>
        ));
    };

    return (

        <div className="content-wrapper">

            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Convenience Fees</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item">
                                    <Link to="/dashboard">Home</Link>
                                </li>
                                <li className="breadcrumb-item active">Convenience Fees</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">

                                <div className="card-header">
                                    <div className="d-md-flex align-items-center justify-content-end">
                                        <Link to="/add-convenience-fees-and-charges" className="btn btn-primary mb-md-0 mb-2 py-1 mr-3">
                                            <i className="fas fa-plus" /> Add Convenience Fees
                                        </Link>
                                        <div className="card-tools">
                                            <div className="input-group input-group-sm" style={{ width: "250px" }}>
                                                <input
                                                    type="text"
                                                    placeholder="Search"
                                                    value={searchTerm}
                                                    onChange={handleSearchChange}
                                                />
                                                <div className="input-group-append">
                                                    <button type="submit" className="btn btn-default">
                                                        <i className="fas fa-search" />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="card-body">

                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <div>
                                            <label className="me-2">Show</label>
                                            <select
                                                value={rowsPerPage}
                                                onChange={(e) => {
                                                    setRowsPerPage(parseInt(e.target.value));
                                                    setCurrentPage(1); // Reset to first page
                                                }}
                                                className="form-control mx-2 form-select d-inline-block w-auto"
                                            >
                                                <option value="10">10</option>
                                                <option value="25">25</option>
                                                <option value="50">50</option>
                                                <option value="100">100</option>
                                            </select>
                                            <span className="ms-2">entries</span>
                                        </div>
                                        <div>
                                            {/* Optional: Add search or pagination controls here */}
                                        </div>
                                    </div>

                                    <div className="table-responsive">
                                        <table className="table table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th style={{ width: "5%" }}>#</th>
                                                    <th style={{ width: "10%" }}>Title</th>
                                                    <th style={{ width: "10%" }}>Calculation</th>
                                                    <th style={{ width: "10%" }}>Type</th>
                                                    <th style={{ width: "10%" }}>Value</th>
                                                    <th style={{ width: "10%" }}>Min Order Value</th>
                                                    <th style={{ width: "10%" }}>Max Order Value</th>
                                                    <th style={{ width: "10%" }}>Category</th>
                                                    <th style={{ width: "10%" }}>Status</th>
                                                    <th style={{ width: "15%" }}>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {currentCategories.map((category, i) => (
                                                    <tr key={category?.id}>
                                                        <td>{i + 1}</td>
                                                        <td>{category?.title}</td>
                                                        <td>{category?.discount_type}</td>
                                                        <td>{category?.type}</td>
                                                        <td>{category?.value}</td>
                                                        <td>{category?.min_order_value}</td>
                                                        <td>{category?.max_order_value}</td>
                                                        <td className="text-capitalize">{category?.category}</td>
                                                        <td>
                                                            <span
                                                                className={`badge p-2 ${category?.status === "active"
                                                                    ? "badge-success"
                                                                    : "badge-danger"
                                                                    }`}
                                                            >
                                                                {category?.status?.toUpperCase()}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            {category.id != 0 && (
                                                                <div className="d-flex align-items-center" style={{ gap: '10px' }}>
                                                                    <Link to={`/edit-convenience-fees-and-charges/${category.id}`}>
                                                                        <button className="btn btn-primary btn-sm">Edit</button>
                                                                    </Link>
                                                                    <button
                                                                        className="btn btn-danger btn-sm"
                                                                        onClick={() => openModal(category?.id)}
                                                                    >
                                                                        Delete
                                                                    </button>
                                                                </div>
                                                            )} {category.id == 0 && (
                                                                <div className="d-flex align-items-center" style={{ gap: '10px' }}>
                                                                    Default
                                                                </div>
                                                            )}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className="d-md-flex justify-content-between align-items-center mt-3">
                                        <div>
                                            Showing {indexOfFirstCategory + 1} to {Math.min(indexOfLastCategory, filteredCategories.length)} of {filteredCategories.length} entries
                                        </div>
                                        <nav>
                                            <ul className="pagination mb-0">
                                                <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                                    <button className="page-link" onClick={() => setCurrentPage(currentPage - 1)}>
                                                        Previous
                                                    </button>
                                                </li>

                                                {renderPageNumbers()}

                                                <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                                    <button className="page-link" onClick={() => setCurrentPage(currentPage + 1)}>
                                                        Next
                                                    </button>
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Modal show={showModal} onHide={closeModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="text-center p-4">
                        <h5>Are you sure you want to delete ?</h5>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary" onClick={closeModal}>
                        Cancel
                    </button>
                    <button className="btn btn-danger" onClick={confirmDelete}>
                        OK
                    </button>
                </Modal.Footer>
            </Modal>

        </div>



    );
};

export default ConvenienceFeesAndChargesList;

